import { render, staticRenderFns } from "./case3.vue?vue&type=template&id=765035d2&scoped=true&"
import script from "./case3.vue?vue&type=script&lang=js&"
export * from "./case3.vue?vue&type=script&lang=js&"
import style0 from "./case3.vue?vue&type=style&index=0&id=765035d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765035d2",
  null
  
)

export default component.exports